const approvedSelectOption = {
  id: 'APPROVED',
  label: 'Согласовано',
  value: 'APPROVED',
};

export const onApprovalSelectOption = {
  id: 'ON_APPROVAL',
  label: 'На согласовании',
  value: 'ON_APPROVAL',
};

export const approvedSelectOptions = [
  approvedSelectOption,
  onApprovalSelectOption,
  {
    id: 'DENIED',
    label: 'Отклонено',
    value: 'DENIED',
  },
];

export const planTypeApprovedSelectOptions = [
  approvedSelectOption,
  {
    id: 'DENIED',
    label: 'Исключено',
    value: 'DENIED',
  },
];
